<mat-card>
    <mat-card-header class="titreFrm">
      <mat-card-title>LISTE MATI&Egrave;RE</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <mat-card>
            <mat-card-content>
                <app-avt-listes
                    [multipleSelect]="true" 
                    #listeMatiereComponen
                    [heightTable]="'300'"
                    [dataSourceBrut]="[]"
                    [displayedColumnsBrut]="columns"
                    [listBtn]="listBtn"
                    (btnTable)="clickBtnHeat($event)">
                </app-avt-listes>
            </mat-card-content>
        </mat-card>
    </mat-card-content>
</mat-card>